import { render, staticRenderFns } from "./receiptList.vue?vue&type=template&id=970aaedc&scoped=true"
import script from "./receiptList.vue?vue&type=script&lang=js"
export * from "./receiptList.vue?vue&type=script&lang=js"
import style0 from "./receiptList.vue?vue&type=style&index=0&id=970aaedc&prod&scoped=true&lang=css"
import style1 from "./receiptList.vue?vue&type=style&index=1&id=970aaedc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "970aaedc",
  null
  
)

export default component.exports